import { useSeoMeta } from "@unhead/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const ContactPage = () => {
  useSeoMeta({
    title: "Let's FCK!",
    description: "",
  });

  return (
    <div className="min-h-screen flex items-center justify-center pt-24 pb-12 px-4">
      <div className="container mx-auto max-w-2xl text-center">
        <form className="space-y-6 text-left">
          {/* Nickname */}
          <div>
            <label className="block text-white text-sm font-semibold mb-2">Nickname:</label>
            <Input
              type="text"
              placeholder="Enter your nickname..."
              className="bg-[#1a1a1a] border-neutral-700 text-white h-12 w-full"
            />
          </div>

          {/* Orientation */}
          <div>
            <label className="block text-white text-sm font-semibold mb-2">Orientation:</label>
            <Input
              type="text"
              placeholder="How do you swing?"
              className="bg-[#1a1a1a] border-neutral-700 text-white h-12 w-full"
            />
          </div>

          {/* Kinks */}
          <div>
            <label className="block text-white text-sm font-semibold mb-2">Kinks:</label>
            <Input
              type="text"
              placeholder="What makes you tingle?"
              className="bg-[#1a1a1a] border-neutral-700 text-white h-12 w-full"
            />
          </div>

          {/* Sins and shameful events */}
          <div>
            <label className="block text-white text-sm font-semibold mb-2">Sins and shameful events:</label>
            <Textarea
              placeholder="Confess your deepest desires..."
              rows={6}
              className="bg-[#1a1a1a] border-neutral-700 text-white w-full"
            />
          </div>

          <div className="text-center">
            <Button
              type="submit"
              size="lg"
              className="bg-white text-black hover:bg-neutral-200 font-bold text-lg px-10 py-6"
            >
              Let's FCK!
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactPage;